import type { RegisterFormFields } from './Context'
import { useContext } from './Context'
import { useRecaptcha, useToast } from '@ztechapps/common.hook'

export const useSubmitRegister = () => {
  const { onSubmit, recaptchaSiteKey, setErrorMessage } = useContext()

  const { getToken } = useRecaptcha({ recaptchaSiteKey })

  const { showSuccess } = useToast()

  return async (args: RegisterFormFields, formikbag) => {
    const { setSubmitting } = formikbag

    try {
      setSubmitting(true)

      const recaptchaToken = await getToken()

      if (!recaptchaToken && recaptchaSiteKey) throw new Error('INTERNAL ERROR: Google reCAPTCHA is still not ready.')

      setErrorMessage('')

      args.recaptchaToken = recaptchaToken

      const result = await onSubmit(args, formikbag)

      showSuccess({ message: 'You have successfully registered' })

      return result
    } catch (e) {
      setErrorMessage(e?.message ?? e)
    } finally {
      setSubmitting(false)
    }
  }
}
